/**
 * Sonucu paylaşma.
 *
 * Üç kademe, cihaz ne kadarını destekliyorsa:
 *   1. Görselle birlikte sistem paylaşım penceresi (Android/iOS, WhatsApp ve
 *      Instagram hikâyesi buradan çıkıyor).
 *   2. Görsel desteklenmiyorsa yalnızca metin paylaşımı.
 *   3. Hiçbiri yoksa (masaüstü tarayıcılar) metni panoya kopyala + PNG'yi indir.
 *
 * Her durumda ne olduğunu çağıran biliyor; kullanıcıya "kopyalandı" ya da
 * "indirildi" demek bunun için gerekiyor.
 */

export type ShareOutcome = "shared" | "copied" | "downloaded" | "cancelled" | "failed";

function canShareFiles(files: File[]): boolean {
  return (
    typeof navigator.canShare === "function" &&
    typeof navigator.share === "function" &&
    navigator.canShare({ files })
  );
}

/** Kullanıcı paylaşım penceresini kapattı mı? Hata sayılmamalı. */
function isAbort(error: unknown): boolean {
  return error instanceof DOMException && error.name === "AbortError";
}

function download(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Bırakmazsak blob bellekte kalır.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

async function copy(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export async function shareResult(
  image: Blob,
  text: string,
  title: string,
  fileName = "muhtesem-kelime.png",
): Promise<ShareOutcome> {
  const file = new File([image], fileName, { type: "image/png" });

  if (canShareFiles([file])) {
    try {
      await navigator.share({ files: [file], text, title });
      return "shared";
    } catch (error) {
      if (isAbort(error)) return "cancelled";
      // Paylaşım penceresi açılamadıysa aşağıdaki kademelere düşüyoruz.
    }
  }

  if (typeof navigator.share === "function") {
    try {
      await navigator.share({ text, title });
      return "shared";
    } catch (error) {
      if (isAbort(error)) return "cancelled";
    }
  }

  const copied = await copy(text);
  download(image, fileName);
  return copied ? "copied" : "downloaded";
}
